"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Redirect = {
    type: "structure",
    required: [],
    members: {
        HostName: {
            shape: {
                type: "string"
            }
        },
        HttpRedirectCode: {
            shape: {
                type: "string"
            }
        },
        Protocol: {
            shape: {
                type: "string"
            }
        },
        ReplaceKeyPrefixWith: {
            shape: {
                type: "string"
            }
        },
        ReplaceKeyWith: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Redirect.js.map